import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'

export default function Update() {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState('');
	const [maticnibrojlovca, setMaticniBrojLovca] = useState('');
	const [ime, setIme] = useState('');
	const [prezime, setPrezime] = useState('');
	const [adresa, setAdresa] = useState('');
	const [telefon, setTelefon] = useState('');
	const [lovackodrustvo, setLovackoDrustvo] = useState('');
	const [brojlovackodrustvo, setBrojLovackoDrustvo] = useState('');
    const [datumpolaganja, setDatumPolaganja] = useState('');
    const [vrstaclanstva, setVrstaClanstva] = useState('');
	const [photo, setPhoto] = useState('');
	const [lovackilist, setLovackiList] = useState(false);
	
	
	console.log(localStorage.getItem('adresa'));
	
	useEffect(() => {
        setId(localStorage.getItem('id'))
        setMaticniBrojLovca(localStorage.getItem('maticnibrojlovca'));
		setIme(localStorage.getItem('ime'));
        setPrezime(localStorage.getItem('prezime'));
        setAdresa(localStorage.getItem('adresa'));
        setTelefon(localStorage.getItem('telefon'));
        setLovackoDrustvo(localStorage.getItem('lovackodrustvo'));
        setDatumPolaganja(localStorage.getItem('datumpolaganja'));
        setVrstaClanstva(localStorage.getItem('vrstaclanstva'));
        setPhoto(localStorage.getItem('photo'));
        setLovackiList(localStorage.getItem('lovackilist'));
		
	}, []);
	
	const updateAPIData = () => {
		console.log(id);
		axios.put(`http://89.46.196.228:3000/api/hunters/${id}`,
			{
				"maticnibrojlovca": maticnibrojlovca,
				"ime": ime,
				"prezime": prezime,
				"adresa": adresa,
				"telefon": telefon,
				"lovackodrustvo": lovackodrustvo,
				"brojlovackodrustvo": brojlovackodrustvo,
				"datumpolaganja": datumpolaganja,
				"vrstaclanstva": vrstaclanstva,
				"photo": photo,
				"lovackilist": lovackilist
			}
			).then(() => {
            navigate('/SLOBiHClanovi')
        })
    }

    return (
	    <div className="main">
        <div>
            <Form className="create-form">
				<Form.Field>
                    <Label>Maticni broj</Label>
                    <input placeholder='Matični broj' value={maticnibrojlovca} onChange={(e) => setMaticniBrojLovca(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Ime</Label>
                    <input placeholder='Ime' value={ime} onChange={(e) => setIme(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Prezime</Label>
                    <input placeholder='Prezime' value={prezime} onChange={(e) => setPrezime(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Adresa</Label>
                    <input placeholder='Adresa' value={adresa} onChange={(e) => setAdresa(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Telefon</Label>
                    <input placeholder='Telefon' value={telefon} onChange={(e) => setTelefon(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Lovačko društvo</Label>
                    <input placeholder='Lovačko društvo' value={lovackodrustvo} onChange={(e) => setLovackoDrustvo(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Datum lovačkog ispita</Label>
                    <input placeholder='Datum lovačkog ispita' value={datumpolaganja} onChange={(e) => setDatumPolaganja(e.target.value)}/>
                </Form.Field>
				
                <Form.Field>
                    <Label>Vrsta članstva</Label>
                    <input placeholder='Vrsta članstva' value={vrstaclanstva} onChange={(e) => setVrstaClanstva(e.target.value)}/>
                </Form.Field>
				
                <Form.Field>
                    <Checkbox label='Lovački list' value={lovackilist} onChange={(e) => setLovackiList(!lovackilist)}/>
                </Form.Field>
                <Button onClick={updateAPIData} type='submit'>Submit</Button>
            </Form>
        </div>
		</div>
    )
}